<script setup lang="ts">
import { signupStepInfo } from '~/apis/signup'

const { state } = useTermsModal()

const termsOfUse = ref('')
const privacy = ref('')

const modalTitle = computed(() => {
  return state.value.type === 'terms' ? '이용약관' : '개인정보처리방침'
})

const handleCloseClick = () => {
  const { $termsModal } = useNuxtApp()
  $termsModal.hide()
}

const getSignupStepInfo = async () => {
  const res = await signupStepInfo()
  // console.log(res.data)

  if (res.data.code === '200') {
    const data = res.data.data
    termsOfUse.value = data.TERMS_OF_USE_HTML
    privacy.value = data.PRIVACY_POLICY_HTML
  }
}

// 모달 상태에 따라 body 스크롤 제어
watch(
  () => state.value.isVisible,
  (isVisible) => {
    if (process.client) {
      if (isVisible) {
        document.body.style.overflow = 'hidden'
        // 히스토리에 상태 추가
        window.history.pushState({ modal: 'terms' }, '', window.location.href)
      } else {
        document.body.style.overflow = ''
      }
    }
  },
)

// 뒤로 가기 버튼 처리
const handlePopState = (event: PopStateEvent) => {
  if (state.value.isVisible) {
    event.preventDefault()
    handleCloseClick()
  }
}

onMounted(() => {
  getSignupStepInfo()

  if (process.client) {
    window.addEventListener('popstate', handlePopState)
  }
})

// 컴포넌트 언마운트 시 정리
onUnmounted(() => {
  if (process.client) {
    document.body.style.overflow = ''
    window.removeEventListener('popstate', handlePopState)
  }
})
</script>
<template>
  <div v-show="state.isVisible" class="terms-modal-overlay">
    <div id="signupWrap" class="terms-modal">
      <div id="signupHeader">
        <div class="inner">
          <a class="btnHeaderBack" @click="handleCloseClick">돌아가기</a>
        </div>
      </div>

      <main id="signupContainer" class="signup">
        <section class="titArea">
          <h2>{{ modalTitle }}</h2>
        </section>

        <section class="signupTerms toastui-editor-contents">
          <div
            v-if="state.type === 'terms'"
            v-dompurify-html="termsOfUse"
          ></div>
          <div v-else v-dompurify-html="privacy"></div>
        </section>

        <section class="btnWrap mt">
          <a class="btnStyle wide" @click="handleCloseClick">확인</a>
        </section>
      </main>
    </div>
  </div>
</template>

<style>
.terms-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  height: 100vh;
}

/* Override background for terms modal */
.terms-modal-overlay:has(#signupWrap) {
  background: var(--BG-LightGray);
}

.terms-modal-overlay #signupWrap {
  background: var(--BG-LightGray);
  height: 100vh;
}
</style>
